import { SecurityAsset } from '@fintronners/react-api/src';
import { OrderType } from '@fintronners/internal-core/src/trade/constants';
import { TradeMarketBuyForm } from './TradeMarketBuyForm';
import { TradeMarketSellForm } from './TradeMarketSellForm';
import { TradeRepeatInvestmentForm } from './TradeRepeatInvestmentForm';
import { TradeLimitBuyForm } from './TradeLimitBuyForm';
import { TradeStopLossForm } from './TradeStopLossForm';
import type { TradeBreakdown } from '@/hooks/trade/useTradeBreakdown';

interface TradeFormProps {
  orderType: OrderType;
  asset: SecurityAsset;
  tradeBreakdown: TradeBreakdown;
  setIsAccountValid: (isValid: boolean) => void;
  isMutualFund?: boolean;
  isFractionable?: boolean;
}

export const TradeForm = ({
  orderType,
  asset,
  tradeBreakdown,
  setIsAccountValid,
  isMutualFund = false,
  isFractionable = false,
}: TradeFormProps) => {
  switch (orderType) {
    case OrderType.MARKET_BUY:
      return (
        <TradeMarketBuyForm
          assetId={asset?.id}
          tradeBreakdown={tradeBreakdown}
          isMutualFund={isMutualFund}
          isFractionable={isFractionable}
        />
      );
    case OrderType.MARKET_SELL:
      return (
        <TradeMarketSellForm
          isMutualFund={isMutualFund}
          isFractionable={isFractionable}
          tradeBreakdown={tradeBreakdown}
        />
      );
    case OrderType.REPEAT_INVESTMENT:
      return <TradeRepeatInvestmentForm setIsAccountValid={setIsAccountValid} />;
    case OrderType.LIMIT_BUY:
      return <TradeLimitBuyForm tradeBreakdown={tradeBreakdown} isFractionable={isFractionable} />;
    case OrderType.STOP_LOSS:
      return (
        <TradeStopLossForm
          securitySymbol={asset?.symbol}
          currentPrice={asset?.market?.last}
          tradeBreakdown={tradeBreakdown}
          isFractionable={isFractionable}
        />
      );
    default:
      return null;
  }
};
